import { render, staticRenderFns } from "./Pipes.vue?vue&type=template&id=233b5530&"
import script from "./Pipes.vue?vue&type=script&lang=ts&"
export * from "./Pipes.vue?vue&type=script&lang=ts&"
import style0 from "./Pipes.vue?vue&type=style&index=0&id=233b5530&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports